import React, { Component } from 'react';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import Session from 'components/Session';
import Error from 'components/ErrorMessage';
/* import { DropIn } from 'braintree-react'; */
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import Footer from 'components/MiniFooter';
import Navbar from 'components/NavOnScroll';
/* import braintree from 'braintree-web'; */
import { logPageView, initGA } from 'utils/analytics';
import Dropin from 'components/PaymentDropin';
import queryString from 'query-string';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import FullScreenLoader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import { getSAProfile } from 'containers/Profile-view/actions';
import { Pricing, Dashboard } from './../../common/routes/routeNames';


import { getClientToken, sendPaymentNonce, postSubscriptionCS } from './actions';
import { selector } from './redux';
import styles from './Payment.scss';// to import local scss fle


class Payment extends Component {
  static propTypes = {
    getClientToken: PropTypes.func.isRequired,
    sendPaymentNonce: PropTypes.func.isRequired,
    clientToken: PropTypes.string.isRequired,
    location: PropTypes.shape().isRequired,
    transaction: PropTypes.shape(),
    profile: PropTypes.instanceOf(Map),
    attributes: PropTypes.instanceOf(Map),
    getSAProfile: PropTypes.func.isRequired,
    history: PropTypes.shape().isRequired,
    showLoader: PropTypes.bool,
    showError: PropTypes.string,
  };
  static defaultProps = {
    transaction: Map(),
    profile: Map(),
    attributes: Map(),
    showLoader: false,
    showError: '',
  };

  static handleSubmit() {
  }

  constructor(props) {
    super(props);
    this.state = { showSuccess: false, plan: false, renderOnce: 0 };
    this.onPaymentMethodReceived = this.onPaymentMethodReceived.bind(this);
    this.callback = this.callback.bind(this);
    this.plans = {
      plan1: { price: 9.99, name: 'one_month_for_12_months', currency: 'USD', pay: 'Pay $9.99 per month for 12 months', url: '9_99_per_month_12_months' },
      plan2: { price: 99, name: 'one_year_plan', currency: 'USD', pay: 'Pay $99 towards one year plan', url: '99_once_12_months' },
      plan3: { price: 14.99, name: 'one_month_for_6_months', currency: 'USD', pay: 'Pay $14.99 per month for 6 months', url: '14_99_per_month_6_months' },
      plan4: { price: 75, name: '6_month_plan', currency: 'USD', pay: 'Pay $75 towards 6 months plan', url: '75_once_6_months' },
      plan5: { price: 19.99, name: 'one_month_for_3_months', currency: 'USD', pay: 'Pay $19.99 per month for 3 months', url: '19_99_per_month_3_months' },
      plan6: { price: 50, name: '3_months_plan', currency: 'USD', pay: 'Pay $50 towards 3 months plan', url: '50_once_3_months' },
      oneMonthPlan: { price: 29.99, name: '1_months_plan', currency: 'USD', pay: 'Pay $29.99 towards 1 month plan', url: '29_99_once_1_month' },
      lifetime: { price: 199, name: 'lifetime', currency: 'USD', pay: 'Pay $199 towards lifetime plan', url: '199_once_lifetime' },
      monthlySubscription: { price: 14.99, name: '14_99_per_month', currency: 'USD', pay: 'Pay $14.99 towards monthly plan', url: '14_99_per_month' },
    };
  }

  componentWillMount() {
    // window.scrollTo(0, 0);
    const { location } = this.props;
    const query = queryString.parse(location.search);
    if (query && Object.prototype.hasOwnProperty.call(query, 'plan') && Object.prototype.hasOwnProperty.call(query, 'once')) {
      this.setState({ query });
      const plan = this.plans[query.plan];
      if (plan && plan.url) {
        this.setState({ plan });
      } else {
        this.setState({ plan: false });
      }
    }
  }

    /** SA Profile will have CustomerID when the user registers for the first time in MyRB and
    * payment_info object won't be present in SA profile now .
    *
    * If the payment is succesful , This CustomerID will be used to Create Customer
    * in Braintree when the User pays for the first time
    * and payment_info object would be added with the plan and transaction details
    * "payment_info": {
        "last_date": "2017-10-17T14:34:10.000Z",
        "payment_customer_id": "a5460af8-a2c4-563b-a7f5-56136558f544",
        "payment_status": true,
        "plan_id": "29_99_once_1_month",
        "transaction_date": "2017-09-17T14:34:10Z"
    }

    If payment_info is not null, it is understood that customer is already added to braintree and so
    if the user is making another payment , we have to send customer_id in payment/clientToken GET
     API as a query parameter.
    For the first time payment, we don't need to send the client_token in this api . */

  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line


    if (this.props.profile && this.props.profile.size > 0) {
      const payment = this.props.profile.get('payment_info');
      const customerId = this.props.profile.get('customer_id');
      const name = this.props.profile.get('fullname');
      const id = this.props.profile.get('id');
      const newState = {
        payment,
        customerId,
        name,
        id,
      };

      let custId = '';

      if (payment) {
        custId = customerId;
      }
      this.props.getClientToken(custId);
        this.setState(newState); //eslint-disable-line
    } else if (this.props.attributes && this.props.attributes.size > 0) {
      const saProfile = this.props.attributes.get('profile');
      this.setState({ email: this.props.attributes.get('email') }); // eslint-disable-line

      if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
        this.props.getSAProfile(saProfile);
      } else {
        this.props.history.push(Pricing);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.clientToken) {
      const temp = this.state.renderOnce + 1;
      this.setState({ renderOnce: temp });
    }
    const { attributes, profile, transaction } = this.props;
    if (nextProps.attributes && !is(nextProps.attributes, attributes)) {
      const saProfile = nextProps.attributes.get('profile');
      this.setState({ email: nextProps.attributes.get('email') });
      if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
        this.props.getSAProfile(saProfile);
      } else {
        this.props.history.push(Pricing);
      }
    } else if (nextProps.profile.size > 0 && !is(nextProps.profile, profile)) {
      let payment = nextProps.profile.get('payment_info');
      if (payment) {
        payment = payment.toJS();
      }
      const customerId = nextProps.profile.get('customer_id');
      const name = nextProps.profile.get('fullname');
      const id = nextProps.profile.get('id');
      const newState = {
        payment,
        customerId,
        name,
        id,
      };

      let custId = '';

      if (payment) {
        custId = customerId;
      }
      this.props.getClientToken(custId);

      this.setState(newState); //eslint-disable-line
    }
    if (nextProps.transaction && !is(nextProps.transaction, transaction)) {
      this.setState({ showSuccess: true });
      this.props.getSAProfile(this.state.id);
      this.props.history.push(Dashboard);
    }
  }

  onPaymentMethodReceived(payment) {
    let pay = {
      customer: {
        firstName: this.state.name,
        lastName: this.state.name,
        company: '',
        email: this.props.attributes.get('email'),
        phone: '',
        fax: '',
        website: '',
        id: this.state.customerId,
      },
      paymentMethodNonce: payment.nonce,
      planId: this.state.plan.url,
      userId: this.state.id,
      payment_info: this.props.profile.get('payment_info'),
    };
    if (this.state.payment) {
      pay = {
        paymentMethodNonce: payment.nonce,
        planId: this.state.plan.url,
        userId: this.state.id,
        payment_info: this.props.profile.get('payment_info'),
      };
    }
    this.props.sendPaymentNonce(pay);
  }

  callback() {
    this.setState({ showLoader: false });
  }

  render() {
    const { clientToken } = this.props;
    const { showSuccess, plan } = this.state;
    const renderDropIn = renderIf(clientToken && clientToken.length > 0);
    /* const paypal = {
      currency: 'USD' }; */
    const renderSuccess = renderIf(showSuccess && plan);
    /* const renderPay = renderIf(!this.state.showLoader); */
    const renderNormal = renderIf(!showSuccess && plan);
    const renderPlanError = renderIf(this.props.showError !== '');
    const renderLoader = renderIf(this.props.showLoader);
    const form = document.querySelector('#payment-form');
    return (
      <div className={cn('row', styles.container)} >
        <Navbar {...this.props} />
        <div className={cn('col s12', styles.dropInContainer)} >
          {renderNormal(
            <span>
              <form onSubmit={Payment.handleSubmit} id="payment-form" className={styles.one} >
                {renderPlanError(
                  <Error message={this.props.showError} />,
                  )}
                <span className={styles.greenIndicator}>{plan.pay}</span>
                <div id="dropin-container" />
                {
                  renderDropIn(

                    <Dropin
                      clientToken={this.props.clientToken}
                      form={form}
                      onPaymentMethodReceived={this.onPaymentMethodReceived}
                    />,

                  )
              }
                <div className={styles.buttonContainer}>
                  <button className={styles.button} type="submit" > PAY NOW </button>
                </div>
              </form>
              {/* {renderPay(
                <button className={styles.button} type="submit" > {plan.pay} </button>,

                )} */}

              {renderSuccess(
                <div> Transaction successfull</div>,
                )}

              {
                    renderLoader(<FullScreenLoader />,
                    )
                }
            </span>,
            )}
        </div>
        <div className={cn('col s12', styles.removePadding)} >
          <Footer />
        </div>
      </div>
    );
  }
}

export default connect(selector, {
  getClientToken,
  postSubscriptionCS,
  sendPaymentNonce,
  getSAProfile,
})(Session(Payment));



// WEBPACK FOOTER //
// ./src/containers/Payment/Payment.js